import { Component, OnInit } from '@angular/core';
import { SearchDeliveryToggleService } from '@search/services/search-delivery-toggle.service';

@Component({
  selector: 'app-search-toggle-filter',
  templateUrl: './search-delivery-toggle-filter.component.html',
  styleUrls: ['./search-delivery-toggle-filter.component.scss'],
})
export class SearchDeliveryToggleFilterComponent implements OnInit {
  toggleIsOn;
  toggleIsDisabled;

  constructor(
    private searchDeliveryToggleService: SearchDeliveryToggleService,
  ) {}

  ngOnInit(): void {
    this.toggleIsDisabled = this.searchDeliveryToggleService.toggleIsDisabled;
    this.toggleIsOn = this.searchDeliveryToggleService.toggleIsOn;
  }

  setToggle() {
    this.searchDeliveryToggleService.toggle();
  }
}
